import React from 'react';
import { IonPage, IonRouterOutlet } from '@ionic/react';
import { Route } from 'react-router-dom';
import SettingsHome from './SettingsHome';
import ContactsSettingsHome from './ContactsSettingsHome';
import ContactsImportSettings from './ContactsImportSettings';
import ContactsPickerSettings from './ContactsPickerSettings';
import NotificationSettings from './NotificationSettings';

const UserSettingsRouter: React.FC = () => (
  <IonPage>
    <IonRouterOutlet>
      <Route exact path="/settings" component={SettingsHome} />
      <Route exact path="/settings/contacts" component={ContactsSettingsHome} />
      <Route
        exact
        path="/settings/contacts/import"
        component={ContactsImportSettings}
      />
      <Route
        exact
        path="/settings/contacts/picker"
        component={ContactsPickerSettings}
      />
      <Route
        exact
        path="/settings/notifications"
        component={NotificationSettings}
      />
    </IonRouterOutlet>
  </IonPage>
);

export default UserSettingsRouter;
